// extracted by mini-css-extract-plugin
export var author = "ComponentReviewsCards-module--author--55ec3";
export var avatar = "ComponentReviewsCards-module--avatar--5db7d";
export var bottom = "ComponentReviewsCards-module--bottom--f9aac";
export var card = "ComponentReviewsCards-module--card--41d72";
export var cardCarousel = "ComponentReviewsCards-module--cardCarousel--e325e";
export var cardContent = "ComponentReviewsCards-module--cardContent--b2453";
export var cardGroup = "ComponentReviewsCards-module--cardGroup--7ac81";
export var cardStack = "ComponentReviewsCards-module--cardStack--27ead";
export var cardWrapper = "ComponentReviewsCards-module--cardWrapper--8e706";
export var carouselSlider = "ComponentReviewsCards-module--carouselSlider--3765c";
export var current = "ComponentReviewsCards-module--current--fe0cf";
export var heading = "ComponentReviewsCards-module--heading--a7516";
export var left = "ComponentReviewsCards-module--left--b4f98";
export var middle = "ComponentReviewsCards-module--middle--ceda4";
export var next = "ComponentReviewsCards-module--next--c95dd";
export var occupation = "ComponentReviewsCards-module--occupation--dff58";
export var picture = "ComponentReviewsCards-module--picture--c0969";
export var right = "ComponentReviewsCards-module--right--72922";
export var section = "ComponentReviewsCards-module--section--dea37";
export var stepperButton = "ComponentReviewsCards-module--stepperButton--c1285";
export var stepperButtonWrapper = "ComponentReviewsCards-module--stepperButtonWrapper--9894a";
export var swipe = "ComponentReviewsCards-module--swipe--a9d36";
export var swipeLeft = "ComponentReviewsCards-module--swipeLeft--d5782";
export var swipeRight = "ComponentReviewsCards-module--swipeRight--221df";
export var wiggle = "ComponentReviewsCards-module--wiggle--792b7";